(function() {
    'use strict';

    angular
        .module('app',['ngSanitize','daterangepicker']).config(function($httpProvider) {
        	$httpProvider.defaults.headers.post['X-CSRF-Token'] = jQuery('meta[name="csrf-token"]').attr("content");
     	    $httpProvider.defaults.timeout = 30000;
             
    	});
})();
